import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthErrorsService {
  private translate = inject(TranslateService);

  private readonly legacyKeyMap: Record<string, string> = {
    'Fields required': 'fieldsRequired',
    'Email not verified': 'emailNotVerified',
    'Too many attempts': 'tooManyAttempts',
    'Account linked to provider': 'accountLinkedToProvider',
    'account_exists': 'accountExists',
    'Default': 'default'
  };

  /**
   * Get an error message by code with optional dynamic parameters
   * @param code Error code (e.g., '103', 'invalid_grant')
   * @param params Dynamic parameters to replace in message (e.g., { email: 'user@example.com' })
   * @returns Translated error message
   */
  getMessage(code: string, params: Record<string, string | number> = {}): string {
    const normalizedCode = this.legacyKeyMap[code] || code;
    const key = `auth.serverErrors.${normalizedCode}`;
    let message = this.translate.instant(key);

    // If key not found, try default
    if (message === key) {
      message = this.translate.instant('auth.serverErrors.default');
    }

    // Replace parameters
    Object.keys(params).forEach(param => {
      message = message.replace(`{{${param}}}`, String(params[param]));
    });

    return message;
  }
}
